import { UserModel, UserModelAPI } from "../../../../models/users/UserModel";

export const getUsersListAdapter = (
    responseAPI: UserModelAPI[]
): UserModel[] => {
    return responseAPI
        ? responseAPI.map((user) => {
              return {
                  id: user.id,
                  fullName: user.fullName,
              };
          })
        : [];
};